export default __webpack_public_path__ + "static/media/kurdistan.28a0147b.svg";